/*
 * shopit-api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.41
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {Suppliers} from './Suppliers';

/**
 * The AgenciesInner model module.
 * @module model/AgenciesInner
 * @version v1
 */
export class AgenciesInner {
  /**
   * Constructs a new <code>AgenciesInner</code>.
   * @alias module:model/AgenciesInner
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AgenciesInner</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AgenciesInner} obj Optional instance to populate.
   * @return {module:model/AgenciesInner} The populated <code>AgenciesInner</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AgenciesInner();
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
      if (data.hasOwnProperty('image_url'))
        obj.image_url = ApiClient.convertToType(data['image_url'], 'String');
      if (data.hasOwnProperty('suppliers'))
        obj.suppliers = Suppliers.constructFromObject(data['suppliers']);
    }
    return obj;
  }
}

/**
 * @member {String} name
 */
AgenciesInner.prototype.name = undefined;

/**
 * @member {String} image_url
 */
AgenciesInner.prototype.image_url = undefined;

/**
 * @member {module:model/Suppliers} suppliers
 */
AgenciesInner.prototype.suppliers = undefined;

